import { Typography } from "@mui/material";
import { Close } from '@material-ui/icons';
import './style.scss';

export const TextClose = props => {
    const { text, closeHandler } = props;

    return (
        <div className='centeredDiv textCloseDiv'>
            <Typography className="tabTitle">{text}</Typography>
            <Close 
                onClick={(event) => {
                    event.stopPropagation();
                    closeHandler();
                }} 
                className={`closeButton ${(localStorage.getItem('skin') && localStorage.getItem('skin').replaceAll('"', ''))}`}/>
        </div>
    );
}